import { render, staticRenderFns } from "./standardComponent.vue?vue&type=template&id=d2584dc8&scoped=true&"
import script from "./standardComponent.vue?vue&type=script&lang=js&"
export * from "./standardComponent.vue?vue&type=script&lang=js&"
import style0 from "./standardComponent.vue?vue&type=style&index=0&id=d2584dc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2584dc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2584dc8')) {
      api.createRecord('d2584dc8', component.options)
    } else {
      api.reload('d2584dc8', component.options)
    }
    module.hot.accept("./standardComponent.vue?vue&type=template&id=d2584dc8&scoped=true&", function () {
      api.rerender('d2584dc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ui-document/components/standardComponent.vue"
export default component.exports